import Header from "../components/Header";
import Footer from "../components/Footer";

export default function About() {
    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>About Us</span>
                    </div>
                </section>

                <section class="web3bank">
                    <div data-lavalamp=""></div>
                    <div data-lavalamp=""></div>
                    <div class="content">
                        <div class="frame3d"></div>
                        <div class="pad texts">
                            <div data-lavalamp=""></div>
                            <div class="left">
                                <h1>About <br /><b>NuGenesis</b></h1>
                                {/* <div class="subtitle">
                            CrossFi App </div> */}
                            </div>

                            <div class="right">
                                <div class="text">
                                    NuGenesis is system of blockchain technologies to reap the potential in the mass adoption of the crypto market. It integrates blockchain load balancers and system validators to efficiently flow data into infinite parallel processing blockchains. The more users, the faster the transaction speed!
                                    <br /><br />
                                    NuGenesis parallel processing blockchains are multilingual cross chains allowing dApps built on Eth, Substrate, Bitcoin and 29 other language systems to be seamlessly interoperable.
                                    <br /><br />
                                    NuGenesis blockchain network configurations are complete and functional, and in-built in the code to constantly improve and innovate. It is entirely gasless. It is zero-carbon emission, and totally Green. </div>
                                {/* <div class="btns">
                                    <a href="#" data-patt="track-btn" class="">Pay with
                                        crypto</a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </section>


                <section class="pad bank-benefits default">
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">The Next-Generation Blockchain for CBDCs and Institutional Settlements</h3>
                                <p class="subtitle">
                                    NuGenesis is a fully completed native blockchain originally built for Government and transnational corporate applications. In the context of building a blockchain for Central Bank Digital Currencies (CBDCs), and an exchange clearing house for settlement, limitations to scaling and speed, latency and reliance on human miners and validators had to be eliminated. Security had to be enhanced, its integrity underscored by Artificial Intelligence (AI) and carbon neutral in its efficiency.
                                </p>

                            </div>
                        </div>
                        <div class="img-frame">
                            <img src="images/nugenesisou/Nugenesisou 1 Dark.gif" alt="" />
                        </div>
                    </div>

                </section>



                <section class="pad bank-benefits white">
                    
                    
                    <div class="cards">
                        <div class="wrapper">
                            <div class="item">
                                <div data-lavalamp=""></div>
                                <h3 class="title">Roadmap 1</h3>
                                <p class="subtitle">
                                Roadmap 1 is fully completed. NuGenesis is a fully operational blockchain system, including a gasless interactive NFT platform, next gen smart contract Digital Notarised Contract (DNC) platform, serialised digital asset platform for next gen Decentralised Finance (DeFi), mutli-coin smart chain and a complete ecosystem including a crypto-centric social media platform (Just Social) and a fully-fledged Fiat-Crypto exchange, LedgerX.
                                </p>
                                <div class="img-frame"><img src="images/nugenesisou/abt-illustration-3.png" alt="" />
                                </div>
                            </div>
                            <div class="item">
                                <div data-lavalamp=""></div>
                                <h3 class="title">Roadmap 2</h3>
                                <p class="subtitle">
                                Roadmap 2 is underway. The interactive NFTs are gamified, level-up and transition into augmented and virtual reality in the meta-realm.

The NuGenesis system has a constant rate of innovation built into the code. The minting system provides for special purpose treasuries to fund the continuous rate of upgrade and innovation.

User governance is encouraged; supported by a number of programs for community building and fostering those wishing to make crypto tech their career, profession and business.
                                </p>
                                <div class="img-frame"><img src="images/nugenesisou/abt-illustration-4.png" alt="" /></div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>
            <Footer />
        </>
    )
}